import { render, staticRenderFns } from "./ManifestoListComponent.vue?vue&type=template&id=3af9ac20&"
import script from "./ManifestoListComponent.vue?vue&type=script&lang=js&"
export * from "./ManifestoListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports